// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsDailyRevenueByPurchaseNamesResult = objectOf({
  string: arrayOf(arrayOf(number)),
});
